import { cloneDeep } from 'lodash'
import Message from '@/components/Message'
import { processImageUrl, extractWidth } from "@/util/pic"
/** 直播赛事内容新增时 数据格式化 */
export const formatAddLive = (data) => {
  const cloneData = cloneDeep(data)
  try {
    /** 处理直播时间 */
    cloneData.matchStartTime = resetSecondsToZero(cloneData.liveTime[0])
    cloneData.matchEndTime = resetSecondsToZero(cloneData.liveTime[1])
    delete cloneData.liveTime
    /** 直播赛事为2 */
    cloneData.type = 2
    cloneData.displayOrder = Number(cloneData.displayOrder)
    /** 如果是失效 */
    if (cloneData.status === 0) {
      cloneData.effectMode = null
    }
    /** 如果指定有效时间 */
    if (cloneData.effectMode === 2) {
      cloneData.effectStartTime = cloneData.effectTime[0]
      cloneData.effectEndTime = cloneData.effectTime[1]
    } else {
      cloneData.effectStartTime = null
      cloneData.effectEndTime = null
    }
    delete cloneData.effectTime
    /** 图片压缩 */
    delete cloneData.teamAImgSelectWidth
    delete cloneData.teamAImgWidth
    delete cloneData.teamBImgSelectWidth
    delete cloneData.teamBImgWidth
  } catch (error) {
    console.error(error)
  }
  return cloneData
}

/** 直播赛事内容编辑时 数据格式化 */
export const formatEditLive = (data) => {
  const cloneData = cloneDeep(data)
  try {
    /** 处理直播时间 */
    cloneData.liveTime = [cloneData.matchStartTime, cloneData.matchEndTime]
    /** 直播赛事为2 */
    cloneData.type = 2
    cloneData.displayOrder = String(cloneData.displayOrder)
    /** 如果是指定时间生效 -> 组装指定时间 */
    if (cloneData.effectMode && cloneData.effectMode === 2) {
      cloneData.effectTime = [cloneData.effectStartTime, cloneData.effectEndTime]
    }
    if ([1, 2].includes(cloneData.status)) {
      cloneData.status = 1
    }
    /** 新增图片填写宽度 */
    const teamAWidth = extractWidth(cloneData.teamAImg)
    if (['300', '700'].includes(teamAWidth)) {
      cloneData.teamAImgSelectWidth = teamAWidth
      cloneData.teamAImgWidth = ''
    } else {
      /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
      if (!teamAWidth) {
        cloneData.teamAImgSelectWidth = '300'
      } else {
        cloneData.teamAImgSelectWidth = -1
        cloneData.teamAImgWidth = teamAWidth
      }
    }
    const teamBWidth = extractWidth(cloneData.teamBImg)
    if (['300', '700'].includes(teamBWidth)) {
      cloneData.teamBImgSelectWidth = teamBWidth
      cloneData.teamBImgWidth = ''
    } else {
      /** 如果是旧的图片会找不到宽度 那么就默认选择300 */
      if (!teamBWidth) {
        cloneData.teamBImgSelectWidth = '300'
      } else {
        cloneData.teamBImgSelectWidth = -1
        cloneData.teamBImgWidth = teamBWidth
      }
    }
  } catch (error) {
    console.error(error)
  }
  return cloneData
}

/** 校验teamA图片宽度 */
export const validateTeamAImageWidth = (form) => {
  const data = cloneDeep(form)
  const { teamAImgSelectWidth, teamAImgWidth } = data;

  // 校验图片宽度是否填写
  if (teamAImgSelectWidth === -1 && !teamAImgWidth) {
    Message.error('请输入左队伍图片宽度');
    return false;
  }

  // 校验宽度格式 (正整数) 范围是1-1000
  if (teamAImgWidth && !/^[1-9]|[1-9]\d{1,2}|1920$/.test(teamAImgWidth)) {
    Message.error('请输入1-1920的正整数的图片宽度');
    return false;
  }

  return true;
}

/** 根据左队伍图片宽度更新图片url */
export const updateTeamAImgUrl = (form) => {
  const data = cloneDeep(form)

  const { teamAImgSelectWidth, teamAImgWidth, teamAImg } = data;
  const width = teamAImgSelectWidth === -1 ? teamAImgWidth : teamAImgSelectWidth;
  data.teamAImg = processImageUrl(teamAImg, width);

  return data
}

/** 校验teamB图片宽度 */
export const validateTeamBImageWidth = (form) => {
  const data = cloneDeep(form)
  const { teamBImgSelectWidth, teamBImgWidth } = data;

  // 校验图片宽度是否填写
  if (teamBImgSelectWidth === -1 && !teamBImgWidth) {
    Message.error('请输入左队伍图片宽度');
    return false;
  }

  // 校验宽度格式 (正整数) 范围是1-1000
  if (teamBImgWidth && !/^[1-9]|[1-9]\d{1,2}|1920$/.test(teamBImgWidth)) {
    Message.error('请输入1-1920的正整数的图片宽度');
    return false;
  }

  return true;
}

/** 根据右队伍图片宽度更新图片url */
export const updateTeamBImgUrl = (form) => {
  const data = cloneDeep(form)

  const { teamBImgSelectWidth, teamBImgWidth, teamBImg } = data;
  const width = teamBImgSelectWidth === -1 ? teamBImgWidth : teamBImgSelectWidth;
  data.teamBImg = processImageUrl(teamBImg, width);

  return data
}

/** 修改时间的秒数 */
function resetSecondsToZero(dateTimeString) {
  // 检查输入字符串是否符合预期格式
  const dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
  if (!dateTimePattern.test(dateTimeString)) {
    throw new Error("Invalid date time format. Expected format: 'YYYY-MM-DD HH:mm:ss'");
  }

  // 将字符串分割成日期部分和时间部分
  const [datePart, timePart] = dateTimeString.split(' ');

  // 将时间部分分割成小时、分钟和秒
  const [hours, minutes,] = timePart.split(':');

  // 将秒数重置为 "00"
  const newTimePart = `${hours}:${minutes}:00`;

  // 返回格式化后的日期时间字符串
  return `${datePart} ${newTimePart}`;
}
